import { render, staticRenderFns } from "./articlePage.vue?vue&type=template&id=4cef8edb&"
import script from "./articlePage.vue?vue&type=script&lang=js&"
export * from "./articlePage.vue?vue&type=script&lang=js&"
import style0 from "./articlePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports